import { render, staticRenderFns } from "./BpInputFile.vue?vue&type=template&id=3d6e78ae&scoped=true&"
import script from "./BpInputFile.vue?vue&type=script&lang=js&"
export * from "./BpInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BpInputFile.vue?vue&type=style&index=0&id=3d6e78ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e78ae",
  null
  
)

export default component.exports